export default class Gate{

    constructor(tip_cont, firma_curenta, stare_firma, tip_entitate, tip_contabilitate)
    {
        this.tip_cont = tip_cont;
        this.firma_curenta = firma_curenta;
        this.stare_firma = stare_firma;
        this.tip_entitate = tip_entitate;
        this.tip_contabilitate = tip_contabilitate;
    }

    isPFA() {
        return this.tip_entitate === 'PFA';
    }

    isPfa() {
        const f = this.firma_curenta;
        if (f && typeof f === 'object') {
            if (f.tip_contabilitate === 'SIMPLIFICATA' || f.tip_entitate === 'PFA') return true;
            const dUpper = (f.denumire || f.denumire_firma || '').toUpperCase();
            if (dUpper.includes('ÎNTREPRINDERE INDIVIDUALĂ') || dUpper.includes('INTREPRINDERE INDIVIDUALA') || dUpper.includes(' I.I.') || dUpper.includes(' PFA') || dUpper.includes(' I.F.') || dUpper.includes(' C.M.I.') || dUpper.includes(' P.F.A.') || dUpper.includes('CABINET') || dUpper.includes(' C.I.') || dUpper.includes(' C.I.P.')) {
                return true;
            }
            if (f.tip_contabilitate === 'COMPLETA') return false;
        }
        if (this.tip_contabilitate === 'SIMPLIFICATA' || this.tip_entitate === 'PFA') return true;
        if (this.tip_contabilitate === 'COMPLETA') return false;
        return false;
    }

    isPlatitorTva() {
        const f = this.firma_curenta;
        if (typeof f === 'object' && f !== null && f.scp_tva !== undefined && f.scp_tva !== null) {
            return Number(f.scp_tva) === 1 || f.scp_tva === true || f.scp_tva === '1';
        }
        return true;
    }


    isClient()
    {
        return Number(this.tip_cont) === 1;
    }
    isArtist()
    {
        return Number(this.tip_cont) === 2;
    }
    isGalerie()
    {
        return Number(this.tip_cont) === 3;
    }
    isAdmin()
    {
        const tc = Number(this.tip_cont);
        return tc >= 10 || tc === 990 || tc === 991 || tc === 996;
    }
    isContabil()
    {
        return Number(this.tip_cont) >= 2;
    }
    canWorkOnFirms()
    {
        return this.isContabil();
    }
    isWebDev()
    {
        return Number(this.tip_cont) === 996;
    }

    // returnează true dacă există o firmă curentă și stare_firma === 2 (Activă)
    firmaActiva() {

        return this.stare_firma == '2';
    }

    areFirmaSelectata() {
        const f = this.firma_curenta;
        if (typeof f === 'object' && f !== null) {
            return !!f.id;
        }
        return (
            f !== null &&
            f !== undefined &&
            f !== 0 &&
            f !== '0' &&
            f !== '' &&
            f !== 'null'
        );
    }

    //areFirmaSelectata(firma_curenta) {
    //    return firma_curenta !== null && firma_curenta !== undefined;
    //}

}